import { render, staticRenderFns } from "./TasksListFilters.vue?vue&type=template&id=38c63aef&scoped=true"
import script from "./TasksListFilters.vue?vue&type=script&lang=ts"
export * from "./TasksListFilters.vue?vue&type=script&lang=ts"
import style0 from "./TasksListFilters.vue?vue&type=style&index=0&id=38c63aef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c63aef",
  null
  
)

export default component.exports